<template>
  <div>
    <v-card flat
            tile>
      <v-toolbar color="secondary"
                 dark
                 flat>
        <v-toolbar-title>{{ $t('details') }}</v-toolbar-title>
      </v-toolbar>
      <event-date-details ref="eventDateDetails"
                          v-bind:event-date="eventDate" />
    </v-card>
  </div>
</template>

<script>
  import EventDateDetails from '@/components/booking/EventDateDetails'

  export default {
    components: {
      EventDateDetails
    },
    name: 'EventDateDetailsCard',
    methods: {
      validate() {
        return this.$refs.eventDateDetails.validate()
      }
    },
    props: {
      eventDate: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "details": "Details"
    },
    "en": {
      "details": "Details"
    }
  }
</i18n>